import {
  renderTaskTableCell,
  TaskTableCellName,
  TaskTableRowVisibility,
} from '../../../Task'
import { getRequestProfileOpenActivitiesCanChangeStatus } from '../RequestProfileOpenActivities.utils'
import { RequestProfileOpenActivitiesManagerCell } from '../RequestProfileOpenActivitiesManagerCell'

export function renderRequestProfileOpenActivitiesCell({
  item,
  name,
  ...restProps
}) {
  switch (name) {
    case TaskTableCellName.Status:
      return renderTaskTableCell({
        ...restProps,
        disabled: !getRequestProfileOpenActivitiesCanChangeStatus(item),
        item,
        name,
      })

    case TaskTableCellName.Manager:
      return (
        <RequestProfileOpenActivitiesManagerCell
          {...restProps}
          item={item}
          name={name}
        />
      )

    case TaskTableCellName.VisibleToTenant:
      return (
        <TaskTableRowVisibility
          {...restProps}
          disabled
          item={item}
          name={name}
        />
      )

    default:
      return renderTaskTableCell({ ...restProps, item, name })
  }
}
